import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import msal from 'vue-msal';
import config from './authentication/config';
import axios from 'axios';
import VueExcelXlsx from 'vue-excel-xlsx';
import VueHtmlToPaper from 'vue-html-to-paper';




const options={
  "name": "_blank",
  "specs": [
    "fullscreen=yes",
    "titlebar=yes",
    "scrollbars=yes"
  ],
  "styles": [
        "/public/print.css",    
    ],
    "timeout": 1000,
    "autoClose": true,
    "windowTitle": "Vue Html To Paper - Vue mixin for html elements printing."
  };

Vue.config.productionTip = false;


Vue.use(msal,{
  auth:{
    clientId: config.clientID,
    tenantId: config.tenantID,
    authority: config.authority,
    validateAuthority:true,
    autoRefreshToken:true,
    onToken: (ctx,error,response)=>{
      try{
        console.log("ctx",ctx);
        console.log("Ontoken",response);
        localStorage.setItem('accessToken', response.idToken.rawIdToken);
      }  
      catch{
        console.log(error);
      }
      
    }
  },
  request:{
    scopes:config.scopes,
  },
  cache:{
    cacheLocation: config.cacheLocation,
    storeAuthStateInCookie: config.storeAuthStateInCookie
  },
  framework:{
    gloablMixin: true
  },
  redirectUri:'http://localhost:8080'
});

Vue.use(VueExcelXlsx);
Vue.use(VueHtmlToPaper,options);

axios.defaults.baseURL=process.env.VUE_APP_API_URL;
axios.interceptors.request.use(
  async request=>{
    return request
  },
  error=>{
    return Promise.reject(error)
  }
);

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app');


 
